//スクロール量を保存
var scrollTop;

//スクロールを固定
function bodyFixedOn() {
  scrollTop = $(window).scrollTop();
  
  $('body').css({
    position: 'fixed',
    width:'100%'
//    top: -scrollTop
  });
}

//スクロールの固定を解除
function bodyFixedOff() {
  $('body').css({
    position: '',
    top: ''
  });
  
  $(window).scrollTop(scrollTop);
}

$('#open_medical_check').click(function(){
  $('#modal_bg').css("display","block");
  $('.medical_modal').css("display","block");
  bodyFixedOn();
});

$('#modal_bg').click(function() {
  $('#modal_bg').css("display","none");
  $('.medical_modal').css("display","none");
    bodyFixedOff();
});

// 複数選択の処理
function fillHidden(hiddenname) {
  var checkboxes = document.querySelectorAll('[hidden-data="'+hiddenname+'"]');
  var hiddenfield = document.getElementById(hiddenname);
  hiddenfield.value = ""
  var i;
  for (i = 0; i < checkboxes.length; i++) {
    var x = checkboxes[i];
    if(x.checked){
      if(hiddenfield.value==""){
        hiddenfield.value = x.value;
        }else{
        hiddenfield.value = hiddenfield.value + ", " + x.value; 
        } 
      }
    }
  }


$(function () {
  $('dl dd input[type=email]').blur(function() {
    if($(this).val()) {
       $(this).parent().parent().parent().children('span').html('');
      } else {
       $(this).parent().parent().parent().children('span').html('この項目は必須項目です。');
    }
  });
});

$("button[type=submit].product-form__submit").on("click", function (e) {
  var error;
  $('dl input[type=hidden]').each(function () {
    if (!$(this).val()) {
      error = true;
      $('.checkbox span.alert').text('この項目は必須項目です。');
    } else {
      $('.checkbox span.alert').text('');
    }
  });
   $('dl input[type=email]').each(function () {
    if (!$(this).val()) {
      error = true;
    } else {
      $(this).parent().parent().next('span.alert').text('');
    }
  });
    $('dl input[type=radio]').each(function () {
    if (!$(this).prop('checked')) {
      error = true;
    } else {
      $(this).parent().parent().next('span.alert').text('');
    }
  });
  if(!error){
    $('#modal_bg').css("display","none");
    $('.medical_modal').css("display","none");
    bodyFixedOff();    
  } else {
    e.preventDefault();
    $('p.add_alert').text('入力内容をご確認ください。');
  }
});